import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faLocationDot,
  faLightbulb,
  faGraduationCap,
  faEarthAmericas,
  faWorm,
  faCube,
  faList,
} from '@fortawesome/free-solid-svg-icons';

export const gameTypes = [
  {
    id: "listmaster",
    name: 'List Challenge',
    description: 'Fill in the blanks! Can you name all the items in the category?',
    aiOutline: 'Categories with definitive answers like "Top 5 Golf Major Winners" or "10 Most Populous Cities".',
    requiresAIGeneration: true,
    isPublic: true,
    icon: ({ className }) => (
      <div className={className}>
        <FontAwesomeIcon icon={faList} style={{ width: '100%', height: '100%' }} />
      </div>
    ),
    role: "free",
    exampleId: "GBcnSSrTYRxx9rpQbqfx",
    exampleName: "Most Populous Cities in the World",
    imageUrl: '/GameTypeImages/listmaster.png',
    additionalImages: [
      '/GameTypeImages/listmasterend.png'
    ],
    options: {
      title: "List Challenge",
      intro: "Complete the list by entering as many correct answers as you can. Each correct answer adds to your score.",
      ctaEnabled: false,
      colorButton: "#8B5CF6",
      data: [
        {
          id: "1",
          category: "Past 10 Super Bowl Winners",
          answers: [
            "Kansas City Chiefs",
            "Los Angeles Rams",
            "Tampa Bay Buccaneers",
            "Kansas City Chiefs",
            "New England Patriots",
            "Philadelphia Eagles",
            "New England Patriots",
            "Denver Broncos",
            "New England Patriots",
            "Seattle Seahawks"
          ],
          hint: "These teams have won the Super Bowl from 2014 to 2023"
        }
      ],
      leaderboard: {
        enabled: true,
        allowMultipleAttempts: false
      },
    },
    exampleTopics: "Try: Top 5 Grossing Movies",
  },
  {
    id: "cubefield",
    name: 'Cube Dash',
    description: 'Dodge the cubes and go as far as you can! Classic arcade action.',
    aiOutline: 'A fast-paced 3D obstacle avoidance game',
    requiresAIGeneration: false,
    isPublic: true,
    icon: ({ className }) => (
      <div className={className}>
        <FontAwesomeIcon icon={faCube} style={{ width: '100%', height: '100%' }} />
      </div>
    ),
    role: "free",
    exampleId: "SPO2yg8vStP3WsbHmb8d",
    options: {    exampleId: "GBcnSSrTYRxx9rpQbqfx",
      exampleName: "Most Populous Cities in the World",
      title: "CubeRun",
      intro: "Use left and right arrow keys to navigate through the cubes",
      ctaEnabled: false,
      colorButton: "#8B5CF6",
      leaderboard: {
        enabled: true,
        allowMultipleAttempts: true
      },
      gameSettings: {
        cubeColor: '#4F46E5',
        playerColor: '#EF4444',
        gridColor: '#E5E7EB',
      }
    },
    summaryDisplayOptions: [
      'score'
    ],
  },
  {
    id: "snake",
    name: 'Snake',
    description: 'Eat, grow, survive! Control your snake and beat your friends\' high scores.',
    aiOutline: 'A customizable snake game where players navigate to collect items while avoiding collisions.',
    requiresAIGeneration: false,
    icon: ({ className }) => (
      <div className={className}>
        <FontAwesomeIcon icon={faWorm} style={{ width: '100%', height: '100%' }} />
      </div>
    ),
    role: "free",
    exampleId: "MyuGGHVNFkx526Z4OTIO",
    exampleName: "Classic Snake: The Ultimate Challenge!",
    imageUrl: '/GameTypeImages/snake.png',
    additionalImages: [
      '/GameTypeImages/snakeend.png'
    ],
    options: {
      title: "Classic Snake Adventure",
      intro: "Navigate your snake through the arena, collecting items to grow longer. But be careful - don't hit the walls or yourself!",
      ctaEnabled: false,
      colorButton: "#8B5CF6",
      backgroundImage: "",
      leaderboard: {
        enabled: true,
        allowMultipleAttempts: true
      },
      hideInstructions: true,
      gameSettings: {
        snakeColor: '#4F46E5',
        foodColor: '#EF4444',
        gridColor: '#E5E7EB',
      }
    },
    summaryDisplayOptions: [
      'score'
    ],
  },
  {
    "id": "hint",
    "name": "Mystery Solver",
    "description": "Can you guess the answer? Use hints to solve puzzles, but fewer hints = higher score!",
    "aiOutline": "A difficult game based on Z-list celebrities...",
    "icon": ({ className }) => (
      <div className={className}>
        <FontAwesomeIcon icon={faLightbulb} style={{ width: '100%', height: '100%' }} />
      </div>
    ),
    "role": "free",
    "exampleId": "mpDxNpruwZ4xDVI8ezkn",
    "exampleName": "Step into History: The Ultimate Figure Challenge!",
    "imageUrl": "/GameTypeImages/hintgame.png",
    "additionalImages": [
      "/GameTypeImages/hintend.png"
    ],
    "options": {
      "title": "Mystery Solver Challenge",
      "intro": "Guess the answer based on the hints provided. You have up to 6 hints to figure it out.",
      "ctaEnabled": false,
      "colorButton": "#F59E0B",
      "backgroundImage": "",
      "data": [
        {
          "id": "1",
          "answer": "Eiffel Tower",
          "hints": [
            "It is located in Paris.",
            "This landmark was completed in 1889.",
            "It is named after the engineer who designed it.",
            "It is one of the most recognizable structures in the world.",
            "It was initially criticized by some of France's leading artists and intellectuals.",
            "It stands at 324 meters tall."
          ]
        }
      ],
      "dummyData": [
        "Empire State Building",
        "Big Ben",
        "Burj Khalifa"
      ],
      leaderboard: {
        enabled: true,
        allowMultipleAttempts: false
      },
    },
    summaryDisplayOptions: [
      'name',
    ],
    requiresAIGeneration: true,
    exampleTopics: "Try: Historical Figures",
  },
  { 
    id: "quiz",
    name: 'Trivia Quiz',
    description: 'Think you know it all? Answer questions and rack up points to beat your friends!',
    aiOutline:'Famous historical events, world capitals, or popular science facts.',
    requiresAIGeneration: true,
    summaryDisplayOptions: [
      'question'
    ],
    icon: ({ className }) => (
      <div className={className}>
        <FontAwesomeIcon icon={faGraduationCap} style={{ width: '100%', height: '100%' }} />
      </div>
    ),
    role: "free",
    exampleId: "x0m90NqGNlVIqF7OYVFl",
    exampleName: "Journey Through Famous Historical Events",
    imageUrl: '/GameTypeImages/quiz.png',
    additionalImages: [
      '/GameTypeImages/quizend.png'
    ],
    options: {
      title: "Trivia Time!",
      intro: "Ready to play? Let's see how well you know your trivia!",
      ctaEnabled: false,
      colorButton: "#3B82F6",
      backgroundImage: "",
      data: [
        {
          id: "1",
          question: "What is the capital of France?",
          options: [
            { text: "Paris", correct: true },
            { text: "London", correct: false },
            { text: "Rome", correct: false },
            { text: "Berlin", correct: false }
          ],
          hint: ""
        },
        {
          id: "2",
          question: "Which landmark is located in New York?",
          options: [
            { text: "Statue of Liberty", correct: true },
            { text: "Eiffel Tower", correct: false },
            { text: "Taj Mahal", correct: false },
            { text: "Sydney Opera House", correct: false }
          ],
          hint: ""
        }
      ],
      leaderboard: {
        enabled: true,
        allowMultipleAttempts: false
      },
    },
    exampleTopics: "Try: Friends TV Show",
  },
  { 
    id: "pindrop",
    name: 'Pin Drop',
    description: 'Drop pins on the map! How accurately can you place famous landmarks?',
    aiOutline:"Famous landmarks in major cities around the world, such as the Eiffel Tower, Statue of Liberty, and Great Wall of China.",
    requiresAIGeneration: true,
    summaryDisplayOptions: [
      'name',
    ],
    icon: ({ className }) => (
      <div className={className}>
        <FontAwesomeIcon icon={faLocationDot} style={{ width: '100%', height: '100%' }} />
      </div>
    ),
    role: "free",
    exampleId: "xIPsE1STca4wmcPFSaRw",
    exampleName: "Global Landmark Adventure: Can You Pin 'Em All?",
    imageUrl: '/GameTypeImages/pindrop.png',
    additionalImages: [
      '/GameTypeImages/pindropmid.png',
      '/GameTypeImages/pindropend.png'
    ],
    options: {
      title: "Pin Drop Challenge",
      intro: "Can you pinpoint these locations on the map? Test your geography skills!",
      ctaEnabled: false,
      colorButton: "#EF4444",
      start_view: {
        lat: 54.5,
        lng: -2,
        zoom: 3
      },
      start_radius: 2,
      zoom_level: 17,
      mapType: "roadmap",
      data: [{
        id: "1",
        lat: 48.85802422036538,
        lng: 2.294508122090164,
        name: "Eiffel tower",
        zoom: 17
      }],
      leaderboard: {
        enabled: true,
        allowMultipleAttempts: false
      },
    },
    exampleTopics: "Try: Famous Landmarks",
  },
  { 
    id: "mapselect",
    name: 'Satellite Sleuth',
    description: 'Guess the location from satellite view! Can you recognize these places from above?',
    aiOutline:"Famous landmarks in major cities around the world, such as the Eiffel Tower, Statue of Liberty, and Great Wall of China.",
    requiresAIGeneration: true,
    icon: ({ className }) => (
      <div className={className}>
        <FontAwesomeIcon icon={faEarthAmericas} style={{ width: '100%', height: '100%' }} />
      </div>
    ),
    role: "free",
    exampleId: "T1jB8Lgtsw7TMez79THL",
    exampleName: "Journey Through Landmarks: A Global Scavenger Quest",
    imageUrl: '/GameTypeImages/mapselect.png',
    additionalImages: [
      '/GameTypeImages/mapmultiend.png'
    ],
    options: {
      title: "Satellite Sleuth",
      intro: "Look down from space and guess the location! How many can you identify?",
      ctaEnabled: false,
      colorButton: "#10B981",
      mapType: "satellite",
      movement: true,
      showIcon: false,
      data: [
        {
          id: "1",
          lat: 40.689247,
          lng: -74.044502,
          name: "Statue of Liberty",
          zoom: 18
        },
        {
          id: "2",
          lat: 48.85802422036538,
          lng: 2.294508122090164,
          name: "Eiffel Tower",
          zoom: 17
        },
        {
          id: "3",
          lat: 27.1751448,
          lng: 78.0421422,
          name: "Taj Mahal",
          zoom: 17
        },
        {
          id: "4",
          lat: -33.8567844,
          lng: 151.2152967,
          name: "Sydney Opera House",
          zoom: 17
        }
      ],
      leaderboard: {
        enabled: true,
        allowMultipleAttempts: false
      },
    },
    summaryDisplayOptions: [
      'name'
    ],
    exampleTopics: "Try: Famous Landmarks",
  },
];

